// day start aniation
// document.addEventListener("DOMContentLoaded", () => {
//   const sectionSelector = ".pdp-section";
//   const excludeSelector = ".no-animate, [data-no-animate]";

//   // Select all eligible elements inside a section (everything visible, except excluded ones)
//   const getAnimatableElements = (section) => {
//     return Array.from(section.querySelectorAll("*"))
//       .filter(el => {
//         const tag = el.tagName.toLowerCase();
//         const isExcluded = el.matches(excludeSelector);
//         const isHidden = window.getComputedStyle(el).display === "none" ||
//                          window.getComputedStyle(el).visibility === "hidden";
//         const isSectionWrapper = el.classList.contains("pdp-section");
//         return !isExcluded && !isHidden && !isSectionWrapper;
//       });
//   };

//   // Group elements roughly by top offset inside the section (for staggered animation)
//   function groupByRow(section, elements) {
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//     const groups = [];
//     const buckets = [];

//     elements.forEach(el => {
//       const top = Math.round((el.getBoundingClientRect().top + window.scrollY) - sectionTop);
//       let foundIndex = buckets.findIndex(k => Math.abs(k - top) <= 8);
//       if (foundIndex === -1) {
//         buckets.push(top);
//         groups.push([el]);
//       } else {
//         groups[foundIndex].push(el);
//       }
//     });

//     return buckets
//       .map((k, i) => ({ top: k, items: groups[i] }))
//       .sort((a, b) => a.top - b.top)
//       .map(g => g.items);
//   }

//   const sections = Array.from(document.querySelectorAll(sectionSelector));
//   if (!sections.length) return;

//   // Observer for individual elements
//   const elementObserver = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       const el = entry.target;
//       if (entry.isIntersecting) {
//         el.classList.add("is-inview");
//         elementObserver.unobserve(el);
//       }
//     });
//   }, {
//     threshold: 0.25,
//     rootMargin: "0px 0px -10% 0px"
//   });

//   // Observer for each section
//   const sectionObserver = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) return;
//       const section = entry.target;
//       const candidates = getAnimatableElements(section);
//       if (!candidates.length) {
//         sectionObserver.unobserve(section);
//         return;
//       }

//       candidates.forEach(el => {
//         if (!el.classList.contains("fade-text")) el.classList.add("fade-text");
//         el.style.transitionDelay = "";
//       });

//       const groups = groupByRow(section, candidates);
//       groups.forEach((group, index) => {
//         const delay = (index * 0.04).toFixed(2) + "s";
//         group.forEach(el => {
//           el.style.transitionDelay = delay;
//           elementObserver.observe(el);
//         });
//       });

//       sectionObserver.unobserve(section);
//     });
//   }, {
//     threshold: 0.15,
//     rootMargin: "0px 0px -5% 0px"
//   });

//   sections.forEach(section => sectionObserver.observe(section));
// });







// inclide ingredient section
// document.addEventListener("DOMContentLoaded", () => {
//   const sectionSelector = ".pdp-section";
//   const excludeSelector = ".no-animate, [data-no-animate]";

//   // Define priority selectors per section type
//   const groupSelectors = [
//     ".ingredient-card",
//     ".testi-grid",
//  "animate-full"


//   ];

//   function getAnimatableElements(section) {
//     // 1️⃣ Try to find grouped elements (like cards)
//     for (const sel of groupSelectors) {
//       const found = section.querySelectorAll(sel);
//       if (found.length > 0) return Array.from(found);
//     }

//     // 2️⃣ Fallback: all visible children (like text blocks)
//     return Array.from(section.querySelectorAll("*")).filter(el => {
//       const tag = el.tagName.toLowerCase();
//       const isExcluded = el.matches(excludeSelector);
//       const isHidden =
//         window.getComputedStyle(el).display === "none" ||
//         window.getComputedStyle(el).visibility === "hidden";
//       const isSectionWrapper = el.classList.contains("pdp-section");
//       return !isExcluded && !isHidden && !isSectionWrapper;
//     });
//   }

//   // --- Group elements roughly by row ---
//   function groupByRow(section, elements) {
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//     const groups = [];
//     const buckets = [];

//     elements.forEach(el => {
//       const top =
//         Math.round((el.getBoundingClientRect().top + window.scrollY) - sectionTop);
//       let foundIndex = buckets.findIndex(k => Math.abs(k - top) <= 8);
//       if (foundIndex === -1) {
//         buckets.push(top);
//         groups.push([el]);
//       } else {
//         groups[foundIndex].push(el);
//       }
//     });

//     return buckets
//       .map((k, i) => ({ top: k, items: groups[i] }))
//       .sort((a, b) => a.top - b.top)
//       .map(g => g.items);
//   }

//   const sections = Array.from(document.querySelectorAll(sectionSelector));
//   if (!sections.length) return;

//   // --- Element Observer ---
//   const elementObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("is-inview");
//         elementObserver.unobserve(entry.target);
//       }
//     });
//   }, { threshold: 0.25, rootMargin: "0px 0px -10% 0px" });

//   // --- Section Observer ---
//   const sectionObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) return;

//       const section = entry.target;
//       const candidates = getAnimatableElements(section);
//       if (!candidates.length) {
//         sectionObserver.unobserve(section);
//         return;
//       }

//       candidates.forEach(el => {
//         el.classList.add("fade-text");
//         el.style.transitionDelay = "";
//       });

//       const groups = groupByRow(section, candidates);
//       groups.forEach((group, index) => {
//         const delay = (index * 0.05).toFixed(2) + "s"; // faster stagger
//         group.forEach(el => {
//           el.style.transitionDelay = delay;
//           elementObserver.observe(el);
//         });
//       });

//       sectionObserver.unobserve(section);
//     });
//   }, { threshold: 0.15, rootMargin: "0px 0px -5% 0px" });

//   sections.forEach(section => sectionObserver.observe(section));
// });



// include flex or grid
// document.addEventListener("DOMContentLoaded", () => {
//   const sectionSelector = ".pdp-section";
//   const excludeSelector = ".no-animate, [data-no-animate]";

//   // --- Helper: find animatable elements based on layout ---
//   function getAnimatableElements(section) {
//     // 1️⃣ Try to find grid/flex containers
//     const containers = Array.from(section.querySelectorAll(":scope > *"))
//       .filter(el => {
//         const style = window.getComputedStyle(el);
//         return (
//           (style.display === "grid" || style.display === "flex") &&
//           !el.matches(excludeSelector)
//         );
//       });

//     // If found, animate only their direct children (e.g., cards)
//     if (containers.length) {
//       const result = [];
//       containers.forEach(container => {
//         const children = Array.from(container.children).filter(
//           child => !child.matches(excludeSelector)
//         );
//         result.push(...children);
//       });
//       if (result.length) return result;
//     }

//     // 2️⃣ Fallback: all visible non-excluded elements
//     return Array.from(section.querySelectorAll("*")).filter(el => {
//       const isExcluded = el.matches(excludeSelector);
//       const isHidden =
//         window.getComputedStyle(el).display === "none" ||
//         window.getComputedStyle(el).visibility === "hidden";
//       const isSectionWrapper = el.classList.contains("pdp-section");
//       return !isExcluded && !isHidden && !isSectionWrapper;
//     });
//   }

//   // --- Group elements by vertical row ---
//   function groupByRow(section, elements) {
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//     const groups = [];
//     const buckets = [];

//     elements.forEach(el => {
//       const top =
//         Math.round((el.getBoundingClientRect().top + window.scrollY) - sectionTop);
//       let foundIndex = buckets.findIndex(k => Math.abs(k - top) <= 8);
//       if (foundIndex === -1) {
//         buckets.push(top);
//         groups.push([el]);
//       } else {
//         groups[foundIndex].push(el);
//       }
//     });

//     return buckets
//       .map((k, i) => ({ top: k, items: groups[i] }))
//       .sort((a, b) => a.top - b.top)
//       .map(g => g.items);
//   }

//   const sections = Array.from(document.querySelectorAll(sectionSelector));
//   if (!sections.length) return;

//   // --- Element Observer ---
//   const elementObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("is-inview");
//         elementObserver.unobserve(entry.target);
//       }
//     });
//   }, { threshold: 0.25, rootMargin: "0px 0px -10% 0px" });

//   // --- Section Observer ---
//   const sectionObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) return;

//       const section = entry.target;
//       const candidates = getAnimatableElements(section);
//       if (!candidates.length) {
//         sectionObserver.unobserve(section);
//         return;
//       }

//       candidates.forEach(el => {
//         el.classList.add("fade-text");
//         el.style.transitionDelay = "";
//       });

//       const groups = groupByRow(section, candidates);
//       groups.forEach((group, index) => {
//         const delay = (index * 0.05).toFixed(2) + "s"; // smoother + faster
//         group.forEach(el => {
//           el.style.transitionDelay = delay;
//           elementObserver.observe(el);
//         });
//       });

//       sectionObserver.unobserve(section);
//     });
//   }, { threshold: 0.15, rootMargin: "0px 0px -5% 0px" });

//   sections.forEach(section => sectionObserver.observe(section));
// });



// juggar
// document.addEventListener("DOMContentLoaded", () => {
//   const sectionSelector = ".pdp-section";
//   const excludeSelector = ".no-animate, [data-no-animate]";

//   // 🔹 Priority selectors per section type
//   const groupSelectors = [
//     ".ingredient-card",
//   ];

//   function getAnimatableElements(section) {
//     // 1️⃣ If section has .animate-full elements → animate them directly (ignore children)
//     const animateFullEls = section.querySelectorAll(".animate-full");
//     if (animateFullEls.length > 0) {
//       return Array.from(animateFullEls);
//     }

//     // 2️⃣ Try known grouped structures (like ingredient/testimonial grids)
//     for (const sel of groupSelectors) {
//       const found = section.querySelectorAll(sel);
//       if (found.length > 0) return Array.from(found);
//     }

//     // 3️⃣ Fallback: all visible non-excluded elements
//     return Array.from(section.querySelectorAll("*")).filter(el => {
//       const isExcluded = el.matches(excludeSelector);
//       const isHidden =
//         window.getComputedStyle(el).display === "none" ||
//         window.getComputedStyle(el).visibility === "hidden";
//       const isSectionWrapper = el.classList.contains("pdp-section");
//       return !isExcluded && !isHidden && !isSectionWrapper;
//     });
//   }

//   // --- Group elements by visual row ---
//   function groupByRow(section, elements) {
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//     const groups = [];
//     const buckets = [];

//     elements.forEach(el => {
//       const top = Math.round(
//         (el.getBoundingClientRect().top + window.scrollY) - sectionTop
//       );
//       let foundIndex = buckets.findIndex(k => Math.abs(k - top) <= 8);
//       if (foundIndex === -1) {
//         buckets.push(top);
//         groups.push([el]);
//       } else {
//         groups[foundIndex].push(el);
//       }
//     });

//     return buckets
//       .map((k, i) => ({ top: k, items: groups[i] }))
//       .sort((a, b) => a.top - b.top)
//       .map(g => g.items);
//   }

//   const sections = document.querySelectorAll(sectionSelector);
//   if (!sections.length) return;

//   // --- Element Observer ---
//   const elementObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("is-inview");
//         elementObserver.unobserve(entry.target);
//       }
//     });
//   }, { threshold: 0.25, rootMargin: "0px 0px -10% 0px" });

//   // --- Section Observer ---
//   const sectionObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) return;

//       const section = entry.target;
//       const candidates = getAnimatableElements(section);
//       if (!candidates.length) {
//         sectionObserver.unobserve(section);
//         return;
//       }

//       candidates.forEach(el => {
//         el.classList.add("fade-text");
//         el.style.transitionDelay = "";
//       });

//       const groups = groupByRow(section, candidates);
//       groups.forEach((group, index) => {
//         const delay = (index * 0.05).toFixed(2) + "s"; // smoother, faster stagger
//         group.forEach(el => {
//           el.style.transitionDelay = delay;
//           elementObserver.observe(el);
//         });
//       });

//       sectionObserver.unobserve(section);
//     });
//   }, { threshold: 0.15, rootMargin: "0px 0px -5% 0px" });

//   sections.forEach(section => sectionObserver.observe(section));
// });


// ul;tra proo max juggar
// document.addEventListener("DOMContentLoaded", () => {
//   const sectionSelector = ".pdp-section";
//   const excludeSelector = ".no-animate, [data-no-animate], button, svg, button *, svg *"; 
//   // ⬆️ exclude buttons, SVGs, and their child elements

//   // 🔹 Priority selectors per section type
//   const groupSelectors = [
//     ".ingredient-card",
//   ];

//   function getAnimatableElements(section) {
//     // 1️⃣ If section has .animate-full elements → animate them directly (ignore children)
//     const animateFullEls = section.querySelectorAll(".animate-full");
//     if (animateFullEls.length > 0) {
//       return Array.from(animateFullEls);
//     }

//     // 2️⃣ Try known grouped structures (like ingredient/testimonial grids)
//     for (const sel of groupSelectors) {
//       const found = section.querySelectorAll(sel);
//       if (found.length > 0) return Array.from(found);
//     }

//     // 3️⃣ Fallback: all visible non-excluded elements
//     return Array.from(section.querySelectorAll("*")).filter(el => {
//       const isExcluded = el.matches(excludeSelector);
//       const isHidden =
//         window.getComputedStyle(el).display === "none" ||
//         window.getComputedStyle(el).visibility === "hidden";
//       const isSectionWrapper = el.classList.contains("pdp-section");
//       return !isExcluded && !isHidden && !isSectionWrapper;
//     });
//   }

//   // --- Group elements by visual row ---
//   function groupByRow(section, elements) {
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//     const groups = [];
//     const buckets = [];

//     elements.forEach(el => {
//       const top = Math.round(
//         (el.getBoundingClientRect().top + window.scrollY) - sectionTop
//       );
//       let foundIndex = buckets.findIndex(k => Math.abs(k - top) <= 8);
//       if (foundIndex === -1) {
//         buckets.push(top);
//         groups.push([el]);
//       } else {
//         groups[foundIndex].push(el);
//       }
//     });

//     return buckets
//       .map((k, i) => ({ top: k, items: groups[i] }))
//       .sort((a, b) => a.top - b.top)
//       .map(g => g.items);
//   }

//   const sections = document.querySelectorAll(sectionSelector);
//   if (!sections.length) return;

//   // --- Element Observer ---
//   const elementObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("is-inview");
//         elementObserver.unobserve(entry.target);
//       }
//     });
//   }, { threshold: 0.50, rootMargin: "0px 0px -10% 0px" });

//   // --- Section Observer ---
//   const sectionObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (!entry.isIntersecting) return;

//       const section = entry.target;
//       const candidates = getAnimatableElements(section);
//       if (!candidates.length) {
//         sectionObserver.unobserve(section);
//         return;
//       }

//       candidates.forEach(el => {
//         el.classList.add("fade-text");
//         el.style.transitionDelay = "";
//       });

//       const groups = groupByRow(section, candidates);
//       groups.forEach((group, index) => {
//         const delay = (index * 0.05).toFixed(2) + "s";
//         group.forEach(el => {
//           el.style.transitionDelay = delay;
//           elementObserver.observe(el);
//         });
//       });

//       sectionObserver.unobserve(section);
//     });
//   }, { threshold: 0.15, rootMargin: "0px 0px -5% 0px" });

//   sections.forEach(section => sectionObserver.observe(section));
// });


// avoiding glitcvh
// document.addEventListener("DOMContentLoaded", () => {
//   const sectionSelector = ".pdp-section";
//   const excludeSelector = ".no-animate, [data-no-animate], button, svg, button *, svg *";
//   const groupSelectors = [".ingredient-card"];

//   function getAnimatableElements(section) {
//     const animateFullEls = section.querySelectorAll(".animate-full");
//     if (animateFullEls.length) return Array.from(animateFullEls);

//     for (const sel of groupSelectors) {
//       const found = section.querySelectorAll(sel);
//       if (found.length) return Array.from(found);
//     }

//     return Array.from(section.querySelectorAll("*")).filter(el => {
//       const isExcluded = el.matches(excludeSelector);
//       const isHidden =
//         window.getComputedStyle(el).display === "none" ||
//         window.getComputedStyle(el).visibility === "hidden";
//       const isSectionWrapper = el.classList.contains("pdp-section");
//       return !isExcluded && !isHidden && !isSectionWrapper;
//     });
//   }

//   function groupByRow(section, elements) {
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//     const groups = [];
//     const buckets = [];

//     elements.forEach(el => {
//       const top = Math.round((el.getBoundingClientRect().top + window.scrollY) - sectionTop);
//       let foundIndex = buckets.findIndex(k => Math.abs(k - top) <= 8);
//       if (foundIndex === -1) {
//         buckets.push(top);
//         groups.push([el]);
//       } else {
//         groups[foundIndex].push(el);
//       }
//     });

//     return buckets
//       .map((k, i) => ({ top: k, items: groups[i] }))
//       .sort((a, b) => a.top - b.top)
//       .map(g => g.items);
//   }

//   const sections = document.querySelectorAll(sectionSelector);
//   if (!sections.length) return;

//   const elementObserver = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         entry.target.classList.add("is-inview");
//         elementObserver.unobserve(entry.target);
//       }
//     });
//   }, { threshold: 0.35, rootMargin: "0px 0px -5% 0px" });

//   sections.forEach(section => {
//     const elements = getAnimatableElements(section);
//     const groups = groupByRow(section, elements);

//     groups.forEach((group, index) => {
//       const delay = (index * 0.04).toFixed(2) + "s";
//       group.forEach(el => {
//         el.classList.add("fade-text");
//         el.style.transitionDelay = delay;
//         elementObserver.observe(el);
//       });
//     });
//   });
// });




  // ScrollTrigger default settings
  // const triggers = {
  //   start: "top bottom",   // trigger when the element's top enters the viewport
  //   endTrigger: "html",    // end the trigger when scrolling the whole document
  //   end: "bottom top",     // trigger ends when the bottom of the element hits top of the viewport
  // };

  // // Loop through each element with data-split-text attribute
  // $( ".product__title" ).each( (i, element) => {
  //   $( element ).addClass( "split-text--rendered" );  // Add a class to mark the element as split

  //   // Split text into words using SplitText plugin
  //   const splitTexts = new SplitText( element, { type: "words", wordsClass: "splitted-text" } );
  //   const words = gsap.utils.toArray( splitTexts.words );  // Convert split words into an array for GSAP to animate

  //   // Create a ScrollTrigger for each element
  //   ScrollTrigger.create({
  //     trigger: $(element),
  //     start: triggers.start,
  //     end: triggers.end,
  //     onEnter: () => {
  //       // Animate words when they come into the viewport
  //       gsap.to(words, {
  //         stagger: 0.1,           // Delay between each word animation
  //         opacity: 1,             // Fade words in
  //         x: 0,                   // Bring words back to original position
  //         duration: 1,            // Animation duration
  //         ease: "power4.out",     // Ease for smooth animation
  //         onComplete() {
  //           $(this.targets()[0]).addClass("is-inview"); // Add class when the animation is complete
  //         }
  //       });
  //     },
  //     onLeaveBack: () => {
  //       // Reset words when they leave the viewport
  //       words.forEach((word) => $(word).removeClass("is-inview"));
  //     }
  //   });
  // });

// 11/5/2025

    // gsap.registerPlugin(ScrollTrigger);

    // // Split each heading into words
    // document.querySelectorAll('.split-text').forEach(el => {
    //   const words = el.textContent.split(' ');
    //   el.innerHTML = words.map(word => `<span class="split">${word}</span>`).join(' ');
    // });

    // // Create animation types
    // document.querySelectorAll('.split-text').forEach(el => {
    //   const spans = el.querySelectorAll('.split');
    //   const type = el.dataset.anim;

    //   let animProps = {};

    //   switch(type) {
    //     case "fade-up":
    //       animProps = { y: 80, opacity: 0 };
    //       break;
    //     case "slide-left":
    //       animProps = { x: 100, opacity: 0 };
    //       break;
    //     case "scale-in":
    //       animProps = { scale: 0.5, opacity: 0 };
    //       break;
    //     case "rotate-in":
    //       animProps = { rotationX: 90, opacity: 0, transformOrigin: "top center" };
    //       break;
    //   }

    //   gsap.from(spans, {
    //     ...animProps,
    //     scrollTrigger: {
    //       trigger: el,
    //       start: "top 80%",
    //       toggleActions: "play none none reverse"
    //     },
    //     ease: "power3.out",
    //     duration: 1,
    //     stagger: 0.08
    //   });
    // });

  // gsap.registerPlugin(ScrollTrigger);

  //   // Split text into spans
  //   document.querySelectorAll('.split-text').forEach(el => {
  //     const words = el.textContent.split(' ');
  //     el.innerHTML = words.map(word => `<span class="split">${word}</span>`).join(' ');
  //   });

  //   // Animate text when it enters the viewport
  //   document.querySelectorAll('.split-text').forEach(el => {
  //     const spans = el.querySelectorAll('.split');
  //     gsap.from(spans, {
  //       scrollTrigger: {
  //         trigger: el,
  //         start: "top 80%",
  //         toggleActions: "play none none reverse"
  //       },
  //       y: 80,
  //       opacity: 0,
  //       ease: "power3.out",
  //       duration: 1,
  //       stagger: 0.08
  //     });
  //   });
  






document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".pdp-section .csp-img");
  console.log("Total images found:", images.length); // Total images selected

  const observerOptions = {
    root: null, // viewport
    rootMargin: "0px",
    threshold: 0.2 // 20% of image visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      console.log("Entry observed:", entry.target); // Log each observed element
      console.log("Is intersecting:", entry.isIntersecting);

      if (entry.isIntersecting) {
        console.log("Adding 'visible' class to:", entry.target);
        entry.target.classList.add("visible");
        observer.unobserve(entry.target); // stop observing after animation
        console.log("Stopped observing:", entry.target);
      }
    });
  }, observerOptions);

  images.forEach((img, index) => {
    console.log(`Observing image ${index + 1}:`, img);
    observer.observe(img);
  });
});


